import React from "react";
import { SmartTicketDisplay } from "../../smart-display/SmartTicketDisplay";
import { SmartCompanyDisplay } from "../../smart-display/SmartCompanyDisplay";
import { SmartContactDisplay } from "../../smart-display/SmartContactDisplay";
import { SmartUserDisplay } from "../../smart-display/SmartUserDisplay";
import { SmartFieldRendererProps } from "../types";

/**
 * Smart field renderer that uses display components for related entities
 */
export function SmartFieldRenderer({ fieldId, value }: SmartFieldRendererProps) {
  if (!value) return <>-</>;

  // Every branch below feeds an id prop typed `string`; the raw cell value is
  // untyped, so stringify once here rather than at each call.
  const id = String(value);

  // Handle ticket display
  if (fieldId === "ticket_id" || fieldId === "ticket_number") {
    return <SmartTicketDisplay ticketId={id} fallbackText={id} />;
  }

  // Handle company display
  if (fieldId === "company_id" || fieldId === "company_name") {
    return <SmartCompanyDisplay companyId={id} fallbackText={id} />;
  }

  // Handle contact display
  if (fieldId === "contact_id" || fieldId === "contact_name") {
    return <SmartContactDisplay contactId={id} fallbackText={id} />;
  }

  // Handle user display
  if (fieldId === "user_id" || fieldId === "assigned_to") {
    return <SmartUserDisplay userId={id} fallbackText={id} />;
  }

  // Default text rendering
  return <>{id.substring(0, 100)}</>;
}

// Made with Bob
